import { generatePath } from "react-router-dom";

const PRECISION_FARMING_SEGMENT = "precision-farming";

const PRECISION_FARMING_ROUTES = {
  asApplied: "as-applied",
  asAppliedDetail: "as-applied/:taskDataId/:taskId",
  files: "files",
  prescriptionMap: "prescription-maps/:mapId",
  prescriptionMaps: "prescription-maps",
  prescriptionMapsCreate: "prescription-maps/create",
  seasonDetail: "seasons/:seasonId",
  seasonParcelImport: "seasons/:seasonId/parcel-import",
  seasons: "seasons",
  seasonsDashboard: "seasons/dashboard",
  serviceDetail: "services/:parcelId/seasons/:seasonId",
} as const;

const precisionFarmingPaths = {
  asApplied: (): string => inModule(PRECISION_FARMING_ROUTES.asApplied),
  asAppliedDetail: (params: { taskDataId: string; taskId: string }): string =>
    inModule(generatePath(PRECISION_FARMING_ROUTES.asAppliedDetail, params)),
  prescriptionMap: (params: { mapId: string }): string =>
    inModule(generatePath(PRECISION_FARMING_ROUTES.prescriptionMap, params)),
  prescriptionMaps: (): string =>
    inModule(PRECISION_FARMING_ROUTES.prescriptionMaps),
  season: (params: { seasonId: string }): string =>
    inModule(generatePath(PRECISION_FARMING_ROUTES.seasonDetail, params)),
  seasons: (): string => inModule(PRECISION_FARMING_ROUTES.seasons),
  serviceDetail: (
    params: { parcelId: string; seasonId: string },
    tab?: string,
  ): string => inModule(serviceDetailRoute(params, tab)),
};

const serviceDetailRoute = (
  params: { parcelId: string; seasonId: string },
  tab?: string,
): string => {
  const path = generatePath(PRECISION_FARMING_ROUTES.serviceDetail, params);
  return tab ? `${path}/${tab}` : path;
};

const inModule = (route: string): string =>
  `${PRECISION_FARMING_SEGMENT}/${route}`;

export {
  PRECISION_FARMING_ROUTES,
  PRECISION_FARMING_SEGMENT,
  precisionFarmingPaths,
  serviceDetailRoute,
};
